export default __webpack_public_path__ + "static/media/rocket_noise.f8decbe5.wav";